import { render, staticRenderFns } from "./FormulationNotesTab.vue?vue&type=template&id=6ed8299e&scoped=true&"
import script from "./FormulationNotesTab.vue?vue&type=script&lang=js&"
export * from "./FormulationNotesTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationNotesTab.vue?vue&type=style&index=0&id=6ed8299e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed8299e",
  null
  
)

export default component.exports